import { Link, useLocation } from "react-router-dom";
import LogoWhite from "../../assets/images/SSD_white_logo.png";
import LogoColor from "../../assets/images/SSD_color_logo.png";
import styled from "styled-components";
import { useEffect, useState } from "react";
import ArrowIcon from "../icons/ArrowIcon";

const HeaderContainer = styled.header`
  position: ${({ $isMain }) => ($isMain ? "absolute" : "relative")};
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  transition: ${({ $isOpen }) =>
    $isOpen ? "background-color 0s" : "background-color 0.3s ease 0.4s"};
  background-color: ${({ $isMain, $isOpen }) =>
    $isOpen ? "white" : $isMain ? "transparent" : "rgb(0, 0, 0, 0.05)"};
`;

const HeaderInner = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  z-index: 100;
  padding: 20px 15px;
`;

const Logo = styled.h1`
  display: flex;
  align-items: center;
`;

const HamburgerButton = styled.button`
  position: relative;
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 80;

  span {
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    background: ${({ $isMain, $isOpen }) =>
    $isOpen ? "#000" : "#fff"};

    transition: all 0.3s ease;
    transform-origin: center;
    transition: ${({ $isOpen }) =>
    $isOpen
      ? "all 0.3s ease"
      : "all 0.3s ease, background-color 0.3s ease 0.4s"};

    &:nth-child(1) {
      top: 50%;
      transform: ${({ $isOpen }) =>
    $isOpen ? "rotate(45deg)" : "translateY(-8px)"};
    }

    &:nth-child(2) {
      top: 50%;
      transform: translateY(-50%);
      opacity: ${({ $isOpen }) => ($isOpen ? "0" : "1")};
    }

    &:nth-child(3) {
      top: 50%;
      transform: ${({ $isOpen }) =>
    $isOpen ? "rotate(-45deg)" : "translateY(6px)"};
    }
  }
`;

const Nav = styled.nav`
  width: ${({ $isOpen }) => ($isOpen ? "100%" : "0")};
  height: calc(100vh - 80px);
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: transparent;
  position: absolute;
  top: 100%;
  left: 0;
  overflow: hidden;
  box-shadow: ${({ $isOpen }) => ($isOpen ? "0 4px 12px rgba(0, 0, 0, 0.1)" : "none")};
`;

const LinkText = styled.span`
  position: absolute;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(0 0 99.9% 99.9%);
  overflow: hidden;
  height: 1px;
  width: 1px;
  padding: 0;
  border: 0;
`;

const NavItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  min-height: 56px;
  padding: 16px 25px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
  background-color: ${({ $isActive }) => ($isActive ? "#f8f9fa" : "#fff")};
  
  &:active {
    background-color: #f0f0f0;
    color: #2aa4d5;
  }
  
  &:hover {
    background-color: #f8f9fa;
    color: #2aa4d5;
  }
`;

const ArrowIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 22px;
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  transform: ${({ $isOpen }) => ($isOpen ? "rotate(90deg)" : "rotate(0deg)")};
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  svg {
    width: 20px;
    height: 20px;
    fill: ${({ $isOpen }) => ($isOpen ? "#2aa4d5" : "#666")};
    transition: fill 0.2s ease;
  }
`;

const NavList = styled.ul`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
  transition: all 0.3s ease-in-out;
  height: 100%;
  width: 100%;
  color: #303030;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
  `;

const NavSubMenuList = styled.ul`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: #fafafa;
`;

const AboutNavSubMenuList = styled(NavSubMenuList)`
  max-height: ${({ $isOpen }) => ($isOpen ? '192px' : '0')};
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
`;
const MembersNavSubMenuList = styled(NavSubMenuList)`
  max-height: ${({ $isOpen }) => ($isOpen ? '240px' : '0')};
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
`;
const ServicesNavSubMenuList = styled(NavSubMenuList)`
  max-height: ${({ $isOpen }) => ($isOpen ? '192px' : '0')};
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
`;
const ConsultingNavSubMenuList = styled(NavSubMenuList)`
  max-height: ${({ $isOpen }) => ($isOpen ? '48px' : '0')};
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
`;

const NavSubMenuLink = styled(Link)`
  width: 100%;
  min-height: 48px;
  line-height: 24px;
  padding: 12px 25px 12px 45px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  color: #555;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 30px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #ccc;
    transition: all 0.2s ease;
  }
  
  &:hover {
    color: #2aa4d5;
    background-color: #f5f5f5;
    padding-left: 50px;
    
    &::before {
      background-color: #2aa4d5;
    }
  }
  
  &:active {
    background-color: #eeeeee;
  }
`;

const LogoImage = styled.img`
transition: opacity 0.3s ease;
opacity: 1;
width: 100%;
height: 100%;
object-fit: contain;
`;

const LogoWrapper = styled.div`
position: relative;
width: 160px;
height: 30px;
object-fit: contain;

  img {
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${({ $switching }) => ($switching ? 1 : 0)};
  transition: opacity 0.3s ease
      ${({ $switching }) => ($switching ? "0s" : "0.3s")};
}
`;

const MobileHeader = () => {
  const isMain = useLocation().pathname === "/";
  const [isOpen, setIsOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState({
    company: false,
    members: false,
    services: false,
    consulting: false,
  });

  const pathname = useLocation().pathname;

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  const toggleNav = () => setIsOpen(!isOpen);
  const toggleSubMenu = (menu) => {
    setIsSubMenuOpen((prev) => {
      const isOpen = prev[menu];
      return {
        company: false,
        members: false,
        services: false,
        consulting: false,
        [menu]: !isOpen,
      };
    });
  };

  return (
    <HeaderContainer $isMain={isMain} $isOpen={isOpen}>
      <HeaderInner>
        <Logo>
          <Link to="/">
            <LogoWrapper $switching={!isMain || isOpen}>
              <LogoImage
                src={LogoWhite}
                alt="회계법인 새시대"
                style={{ opacity: !isOpen ? 1 : 0 }}
              />
              <LogoImage
                src={LogoColor}
                alt="회계법인 새시대"
                style={{ opacity: isOpen ? 1 : 0 }}
              />
            </LogoWrapper>
            <LinkText>회계법인 새시대</LinkText>
          </Link>
        </Logo>
        <HamburgerButton
          $isOpen={isOpen}
          $isMain={isMain}
          onClick={toggleNav}
          aria-label="메뉴 열기"
        >
          <span></span>
          <span></span>
          <span></span>
        </HamburgerButton>
      </HeaderInner>
      <Nav $isOpen={isOpen} aria-label="모바일 네비게이션 메뉴">
        <NavList $isMain={isMain} $isOpen={isOpen} role="menu">
          <NavItem
            onClick={() => toggleSubMenu('company')}
            $isActive={isSubMenuOpen.company}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleSubMenu('company');
              }
            }}
            aria-expanded={isSubMenuOpen.company}
            aria-label="회사소개 메뉴"
          >
            회사소개
            <ArrowIconWrapper $isOpen={isSubMenuOpen.company}>
              <ArrowIcon />
            </ArrowIconWrapper>
          </NavItem>
          <AboutNavSubMenuList $isOpen={isSubMenuOpen.company} role="menu">
            <NavSubMenuLink to="/about?menu=대표이사 인사말" onClick={() => setIsOpen(false)} role="menuitem">대표이사 인사말</NavSubMenuLink>
            <NavSubMenuLink to="/about?menu=연혁" onClick={() => setIsOpen(false)} role="menuitem">연혁</NavSubMenuLink>
            <NavSubMenuLink to="/about?menu=조직도" onClick={() => setIsOpen(false)} role="menuitem">조직도</NavSubMenuLink>
            <NavSubMenuLink to="/about?menu=오시는 길" onClick={() => setIsOpen(false)} role="menuitem">오시는 길</NavSubMenuLink>
          </AboutNavSubMenuList>
          <NavItem
            onClick={() => toggleSubMenu('members')}
            $isActive={isSubMenuOpen.members}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleSubMenu('members');
              }
            }}
            aria-expanded={isSubMenuOpen.members}
            aria-label="구성원 메뉴"
          >
            구성원
            <ArrowIconWrapper $isOpen={isSubMenuOpen.members}>
              <ArrowIcon />
            </ArrowIconWrapper>
          </NavItem>
          <MembersNavSubMenuList $isOpen={isSubMenuOpen.members} role="menu">
            <NavSubMenuLink to="/members?menu=전체보기" onClick={() => setIsOpen(false)} role="menuitem">전체보기</NavSubMenuLink>
            <NavSubMenuLink to="/members?menu=본점" onClick={() => setIsOpen(false)} role="menuitem">본점</NavSubMenuLink>
            <NavSubMenuLink to="/members?menu=구로분실" onClick={() => setIsOpen(false)} role="menuitem">구로분실</NavSubMenuLink>
            <NavSubMenuLink to="/members?menu=강남분실" onClick={() => setIsOpen(false)} role="menuitem">강남분실</NavSubMenuLink>
            <NavSubMenuLink to="/members?menu=광주지점" onClick={() => setIsOpen(false)} role="menuitem">광주지점</NavSubMenuLink>
          </MembersNavSubMenuList>
          <NavItem
            onClick={() => toggleSubMenu('services')}
            $isActive={isSubMenuOpen.services}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleSubMenu('services');
              }
            }}
            aria-expanded={isSubMenuOpen.services}
            aria-label="서비스 메뉴"
          >
            서비스
            <ArrowIconWrapper $isOpen={isSubMenuOpen.services}>
              <ArrowIcon />
            </ArrowIconWrapper>
          </NavItem>
          <ServicesNavSubMenuList $isOpen={isSubMenuOpen.services} role="menu">
            <NavSubMenuLink to="/services?menu=회계감사" onClick={() => setIsOpen(false)} role="menuitem">회계감사</NavSubMenuLink>
            <NavSubMenuLink to="/services?menu=세무자문" onClick={() => setIsOpen(false)} role="menuitem">세무자문</NavSubMenuLink>
            <NavSubMenuLink to="/services?menu=재무자문" onClick={() => setIsOpen(false)} role="menuitem">재무자문</NavSubMenuLink>
            <NavSubMenuLink to="/services?menu=경영자문" onClick={() => setIsOpen(false)} role="menuitem">경영자문</NavSubMenuLink>
          </ServicesNavSubMenuList>
          <NavItem
            onClick={() => toggleSubMenu('consulting')}
            $isActive={isSubMenuOpen.consulting}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleSubMenu('consulting');
              }
            }}
            aria-expanded={isSubMenuOpen.consulting}
            aria-label="상담문의 메뉴"
          >
            상담문의
            <ArrowIconWrapper $isOpen={isSubMenuOpen.consulting}>
              <ArrowIcon />
            </ArrowIconWrapper>
          </NavItem>
          <ConsultingNavSubMenuList $isOpen={isSubMenuOpen.consulting} role="menu">
            <NavSubMenuLink to="/consulting" onClick={() => setIsOpen(false)} role="menuitem">온라인 상담 신청</NavSubMenuLink>
          </ConsultingNavSubMenuList>
        </NavList>
      </Nav>
    </HeaderContainer >
  );
};

export default MobileHeader;
